import React from "react";
import { useEffect, useState } from 'react';
import { useAnalytics } from '../AnalyticsContext'
import { logEvent } from "firebase/analytics";
import { getContactoConfig } from "../firestore";

function Contacto() {

    const analytics = useAnalytics();

    const [configContacto, setConfigContacto] = useState(false);

    useEffect(() => {
        logEvent(analytics, "contacto", {
            screen_name: "Hamburguesa",
        });

        getContactoConf();
    }, []);



    const getContactoConf = async () => {

        const configContacto = await getContactoConfig();

        setConfigContacto(configContacto);

    }

    return (

        <div className="row">
            <div className="col s12 left-align txtBold ft-18">
                Contacto
            </div>
            <div className="col s12 left-align ft-16 fw-400 mt-1">
                {
                    configContacto ?
                        <p>{configContacto.leyendaHorario}</p>
                        :
                        <React.Fragment>
                            <p>Los horarios de atención son de Lunes a Viernes de 9:00 a 17:00 hrs.</p>
                            <p>Puedes contactarnos:</p>
                        </React.Fragment>

                }

            </div>
            {
                configContacto ?
                    <div className="col s12 mt-1 left-align wrapDataProfile brT brB mt-1">
                        <p className="ft-16 fw-600 labelNavy ">Valmex</p>
                        <p className="ft-16 fw-300 labelNavy"> <a href={`tel:+52${configContacto.telefono}`} className="no_txt_deco cursorPointer labelNavy"> {configContacto.telefonotext}</a></p>
                        <p className="ft-16 fw-300 labelNavy mt-2"><a href={`mailto:${configContacto.email}`} className="no_txt_deco cursorPointer labelNavy"
                            onClick={() => {

                                logEvent(analytics, "contacto_correo_vmxsi", {
                                    screen_name: "Hamburguesa",
                                });
                            }}
                        >{configContacto.email}</a></p>
                    </div>

                    : <div className="col s12 mt-1 left-align wrapDataProfile brT brB mt-1">
                        <p className="ft-16 fw-600 labelNavy ">Valmex</p>
                        <p className="ft-16 fw-300 labelNavy"> <a href="tel:+525552791433" className="no_txt_deco cursorPointer labelNavy"> (+52) 55 5279 1433</a></p>
                        <p className="ft-16 fw-300 labelNavy mt-2"><a href="mailto:solucionesempleados@valmex.mx" className="no_txt_deco cursorPointer labelNavy"
                            onClick={() => {

                                logEvent(analytics, "contacto_correo_vmxsi", {
                                    screen_name: "Hamburguesa",
                                });
                            }}
                        >solucionesempleados@valmex.mx</a></p>
                    </div>
            }

        </div>
    )
}


export default Contacto;